import React from "react";
import { useTranslation } from "react-i18next";

const TeamTabs = ({ activeTab, onChange, teamCount, pendingCount }) => {
  const { t, i18n } = useTranslation();

  const tabs = [
    { key: "team", label: t("manageTeam.tabs.team", "Team"), count: teamCount },
    { key: "pending", label: t("manageTeam.tabs.pending", "Pending Invitations"), count: pendingCount },
  ];

  return (
    <div className="team-tabs" dir={i18n.dir()} lang={i18n.language}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          className={`team-tab ${activeTab === tab.key ? "active" : ""}`}
          onClick={() => onChange(tab.key)}
        >
          {tab.label}
          <span className="team-tab-count">{tab.count}</span>
        </button>
      ))}
    </div>
  );
};

export default TeamTabs;
